<div class="demo {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center legend-list">
				<div class="social-demographic-gender-list-cntr" *ngIf="hasData && legend.length == 2">
					<span class="toggle-text">{{ legend[0].value }}</span>
					<ui-switch size="small" (change)="onChangeEvent($event)"></ui-switch>
					<span class="toggle-text">{{ legend[1].value }}</span>
				</div>
				<div class="demographics-legends" *ngIf="hasData && legend.length == 3">
					<div
						class="social-demographic-label-link"
						*ngFor="let legendItem of legend"
						[ngClass]="{ 'Active-legend': currentLegendItem === legendItem.value }"
						(click)="setLegendAndReDraw(legendItem.value)"
					>
						{{ legendItem.value }}
					</div>
				</div>
				<div class="chartDiv" *ngIf="seriesObjVal && chartConfig">
					<app-generic-chart [configuration]="chartConfig" [data]="seriesObjVal"></app-generic-chart>
				</div>
			</div>
			<div class="map-no-data no-data-text" *ngIf="!hasData">{{ nodatamessage }}</div>
		</div>
	</div>
</div>
